const urlApi = 'https://apis.wavve.com'
const urlMember = 'https://member.wavve.com'
const urlBilling = 'https://bill.wavve.com'

export default {
  // --------------------------------------------------------------------------
  // DOMAIN
  // --------------------------------------------------------------------------
  URL_API: urlApi,
  URL_DOMAIN: location.hostname,
  URL_PROTOCOL_WITH_DOMAIN: location.protocol + '//' + location.hostname,
  URL_COOKIE_DOMAIN: (location.hostname === 'localhost' ? 'localhost' : 'wavve.com'),
  URL_OLAP_LOG: 'http://olaplog.smartmediarep.com/api/v1/olap/olap.sb',
  URL_PROTOCOL_DEEP_LINK: 'captvpooq:/',

  // --------------------------------------------------------------------------
  // PayLetter URL
  // --------------------------------------------------------------------------
  URL_BILLING_PAYMENT: urlBilling + '/Payment', // 이용권 단건 구매 페이지
  URL_BILLING_PRODUCT_COIN: urlBilling + '/ProductCoin', // 코인 충전 페이지
  URL_BILLING_CHANGE_PAYMENT_METHOD: urlBilling + '/ChangeMethod', // 결제수단 변경 페이지

  PROTOCOL_HTTP: 'http:',
  PROTOCOL_HTTPS: 'https:',

  // --------------------------------------------------------------------------
  // Pooq Member URL
  // --------------------------------------------------------------------------
  URL_MEMBER_SIGNUP: urlMember + '/account',
  URL_MEMBER_FIND_ID: urlMember + '/find/id',
  URL_MEMBER_FIND_PASSWORD: urlMember + '/find/password',
  URL_MEMBER_AUTH_VERIFY_AGE: urlMember + '/auth/verifyage',
  URL_MEMBER_ME: urlMember + '/me',

  // --------------------------------------------------------------------------
  // Message
  // --------------------------------------------------------------------------
  MSG_NEED_FOR_MOVING_LOGIN: '로그인 후 이용하실 수 있습니다.\n로그인 페이지로 이동하시겠습니까?',
  MSG_VOUCHER_SNS_ALERT: '해당 SNS ID로 이용권 구매 후 SNS를 탈퇴하시면 Wavve 서비스를 이용하실 수 없습니다. 이점 꼭 유의하세요.',
  MSG_COIN_SNS_ALERT: '해당 SNS ID로 코인 충전 후 SNS를 탈퇴하시면 Wavve 서비스를 이용하실 수 없습니다. 이점 꼭 유의하세요.',
  MSG_MOVING_MYPOOQ_COIN: '쿠폰 등록이 완료되었습니다.\n코인함으로\n이동하시겠습니까?',
  MSG_MOVING_MYPOOQ_COUPON: '쿠폰 등록이 완료되었습니다.\n보관함으로\n이동하시겠습니까?',
  MSG_MYPOOQ_COUPON_NO_VALUE: '쿠폰번호를 입력해 주세요.',
  MSG_MYPOOQ_COUPON_COMPLETE: '쿠폰 등록이 완료되었습니다.',
  MSG_MYPOOQ_ASK_PASS_UNSUBSCRIBE: '쿠폰 자동결제를 해지 하시겠습니까?',
  MSG_MYPOOQ_CONFIRM_COIN_UNSUBSCRIBE: '코인 자동결제를 해지 하시겠어요?',
  MSG_MYPOOQ_CONFIRM_COIN_REVOKE_SUBSCRIBE: '코인 자동결제를 해지를 취소 하시겠어요?',
  MSG_MYPOOQ_CONFIRM_CANCEL_EDIT: '취소시 내용이 저장되지 않습니다.\n취소하시겠어요?',
  MSG_MYPOOQ_COMPLETE_UNSUBSCRIBE: '자동결제가 해지되었습니다.\n자동결제를 다시 유지하고 싶으신 경우\n익일부터 이용권 만료일 하루 전까지\n[자동결제 해지 취소]가 가능합니다.',
  MSG_MYPOOQ_ASK_CANCEL_UNSUBSCRIBE: '자동결제 해지를 취소하겠습니까? 취소 시 원 자동결제 예정일인 YYYY-MM-DD에 자동결제가 재개됩니다.',
  MSG_MYPOOQ_CANCEL_COMPLETE_UNSUBSCRIBE: '감사합니다.\n해지신청이 취소되었습니다.',
  MSG_ASK_ADD_LIVE_ALARM: '시청예약 하시겠습니까? \n시청예약 알림은 모바일앱 PUSH 알림으로 전송됩니다. 모바일 앱 설치 및 PUSH 알림 동의 여부를 꼭 확인해주세요!',
  MSG_COMPLETE_ADD_LIVE_ALARM: '시청 예약이 설정되었어요.',
  MSG_ASK_DELETE_LIVE_ALARM: '시청 예약을 취소하시겠어요?',
  MSG_COMPLETE_DELETE_LIVE_ALARM: '시청 예약 알림이 취소되었어요.',
  MSG_COMPLETE_ADD_ZZIM_PROGRAM: '관심 프로그램으로 등록했어요.\n새로운 에피소드가 올라오면 모바일 앱 PUSH 알림으로 알려드릴게요.\n모바일 앱 설치 및 PUSH 알림 동의 여부를 꼭 확인해주세요!',
  MSG_COMPLETE_ADD_ZZIM_LIVE: '관심 채널로 등록했어요.',
  MSG_COMPLETE_ADD_ZZIM_MOVIE: '관심 영화로 등록했어요.',
  MSG_ASK_DELETE_ZZIM_PROGRAM: '프로그램 ‘좋아요’ 를\n취소하시겠어요? 좋아요 취소 시\n신규 회차 업로드 알림도\n해제됩니다.',
  MSG_ASK_DELETE_ZZIM_LIVE: '채널 ‘좋아요’를 취소하시겠어요?',
  MSG_ASK_DELETE_ZZIM_MOVIE: '영화 ‘좋아요’를 취소하시겠어요?',
  MSG_COMPLETE_DELETE_ZZIM_PROGRAM: '관심 프로그램 등록을 취소했어요.',
  MSG_COMPLETE_DELETE_ZZIM_LIVE: '관심 채널 등록을 취소했어요.',
  MSG_COMPLETE_DELETE_ZZIM_MOVIE: '관심 영화 등록을 취소했어요.',
  MSG_SHARE_COMPLETE_COPY_LINK: '링크를 복사했어요.\n원하는 곳에 붙여넣기(Ctrl+V)해주세요.',
  MSG_ASK_DELETE_USER_QNA: '선택하신 문의 내역을 삭제하시겠습니까?',
  MSG_COMPLETE_ADD_ZZIM_THEME: '관심 에디터Pick으로 등록했어요.',
  MSG_COMPLETE_DELETE_ZZIM_THEME: '관심 에디터Pick 등록을 취소했어요.',
  MSG_ONLY_INPUT_FOUR_DIGITS: '숫자 4자리를 입력해주세요.',
  MSG_ADULT_PASSWORD_RESET: '성인 비밀번호를 초기화하시겠습니까?\n초기화하면 기존 성인 비밀번호는 삭제되며\n성인인증 후 새로운 성인 비밀번호를 설정합니다.',
  MSG_GAME_RESERVE_STATUS_CONFIRM: '시청 예약 하시겠습니까?\n 알림은 모바일앱 PUSH 알림으로 전송됩니다. 모바일 앱 설치 및 PUSH 알림 동의 여부를 꼭 확인해주세요!',
  MSG_GAME_END: '해당 경기는 종료되었습니다.',
  MSG_GAME_CANCEL: '해당 경기는 현지 사정으로 취소되었습니다.',
  MSG_DO_NOT_SUPPORT_LIVE_BROADCAST: 'Wavve에서 LIVE 중계 서비스를 지원하지 않는 경기입니다.\n다른 경기를 이용해주세요.',
  MSG_GAME_SUSPENDED: '해당 경기는 현지 사정으로 일시정지 되었습니다.',
  ZZIM_BLOCK_MESSAGE: '죄송합니다. 해당 콘텐츠는 구독 기능을 지원하지 않습니다.',
  MSG_COMMON_ERROR: '요청을 완료 할 수 없습니다.\n고객 센터로 문의 바랍니다.',
  MSG_CONFIRM_SELECT_DELETE_UNLIMITED_PERIOD: '영구소장 콘텐츠가 포함되어 있습니다. \n삭제하시겠습니까?',
  MSG_CONFIRM_ALL_DELETE_UNLIMITED_PERIOD: '영구소장 콘텐츠가 포함되어 있습니다. \n전체 내역을 삭제하시겠습니까?',
  MSG_CONFIRM_SELECT_DELETE_SALES_EXPIRED: '삭제 시 시청이 불가능한 \n판매 종료된 콘텐츠가 포함되어 있습니다.\n삭제하시겠습니까?',
  MSG_CONFIRM_ALL_DELETE_SALES_EXPIRED: '삭제 시 시청이 불가능한 \n판매 종료된 콘텐츠가 포함되어 있습니다.\n전체 내역을 삭제하시겠습니까?'
}
